const chartId = "chart-1"
let Chart = require('chart.js');
Chart.defaults.global.defaultFontFamily = 'acumin-pro';

const _groupBy = require('lodash/groupBy')
const _each = require('lodash/each')

const data = require('./data');
const config = require('../../../config');
const full = config.colorHues.full; //full colors
const eighty = config.colorHues.eighty; //80% colors

const groupedData = _groupBy(data, "Entity");

let datasets = [];
let labels = [];
let i = 0;
_each(groupedData, function(group) {
  var country = group[0].Entity;
  if (country == "United Kingdom") country = "U.K." //make it a little shorter
  if (country == "United States") country = "U.S." //make it a little shorter
  let obj = {
    label: country,
    data: [],
    backgroundColor: eighty[i],
    borderColor: full[i],
    borderWidth: 1,
    fill: false,
    lineTension: 0,
  }
  if (group[0].Entity == "United States") obj.borderWidth = 3;

  _each(group, function(row) {
    labels.push(row.Year)
    obj.data.push(row['Life.expectancy..years.'])
  })
  datasets.push(obj)
  i++;
})
labels = [...new Set(labels)]

let ctx = document.getElementById(chartId).getContext('2d');

new Chart(ctx, {
  type: 'line',
  data: {
    labels: labels,
    datasets: datasets.reverse()
  },
  options: {
    responsive: true,
    aspectRatio: window.innerWidth > 992 ? 16 / 9 : 1,
    onResize: function(chartObj) {
      chartObj.aspectRatio = window.innerWidth > 992 ? 16 / 9 : 1;
      chartObj.update()
    },
    scales: {
      yAxes: [{
        ticks: {
          beginAtZero: false
        },
        scaleLabel: {
          display: true,
          labelString: 'Life Expectancy'
        }
      }],
      xAxes: [{
        scaleLabel: {
          display: true,
          labelString: 'Year'
        }
      }]
    }
  }
})